import React from "react";
import { Route, Switch } from "react-router-dom";
import Admin from './admin'

const App = ({ match }) => {
  return (
    <div className="gx-main-content-wrapper">
      <Switch>
        <Route path={`${match.url}`} component={Admin} />
      </Switch>
    </div>
  )
};

export default App;
